import { render, staticRenderFns } from "./EntityBusinessPlan.vue?vue&type=template&id=240e2a08"
import script from "./EntityBusinessPlan.vue?vue&type=script&lang=js"
export * from "./EntityBusinessPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports